import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from '@app/core/app-config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ChannelNotification {
  id: number;
  notification_id: string;
  notification_type: string;
  title: string;
  subtitle: string;
  description: string | null;
  cta_url: string;
  is_read: boolean;
  platform: string;
}

interface ChannelNotificationsResponse {
  data: ChannelNotification[];
}

@Injectable({
  providedIn: 'root'
})
export class ChannelNotificationsService {
  private readonly notificationsUrl = `${config.API_URL}/settings/channels`;

  constructor(private http: HttpClient) {}

  getChannelNotifications(channelId: number): Observable<ChannelNotification[]> {
    return this.http
      .get<ChannelNotificationsResponse>(`${this.notificationsUrl}/${channelId}/notifications`)
      .pipe(map(response => response.data));
  }
}
